module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Design/Flip-horizontal-21ab47a29cd7644f4ed4341792df6235.svg";